import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { resetPasswordValidation } from "./passwordValidation";
import { resetForgetPassword } from "../../../services/user";

function ResetPassword() {
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const history = useHistory();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(resetPasswordValidation),
    mode: "onBlur",
  });

  const onSubmit = async (data) => {
    setErrorMessage("");
    setSuccessMessage("");
    setLoading(true);
    const idToken = sessionStorage.getItem("idToken");
    try {
      // Uncomment and use your real reset logic here:
      await resetForgetPassword(idToken, data.password);
      setSuccessMessage(
        "Your password has been reset successfully. You can now log in."
      );
      setLoading(false);
      setTimeout(() => {
        history.push("/signin");
      }, 2000);
      reset();
    } catch (error) {
      setErrorMessage("Failed to reset password. Please try again.");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-[#f8fafc] to-[#e0e7ef] py-8 px-4">
      <div className="w-full max-w-2xl bg-white rounded-2xl shadow-2xl px-12 py-8 flex flex-col items-center animate-fade-in">
        <img src="/zstore_logo.png" alt="Z-Store Logo" className="h-16 mb-6" />
        <h2 className="text-3xl font-bold text-gray-900 mb-2 text-center">
          Reset your password
        </h2>
        <p className="text-gray-500 mb-8 text-center text-base">
          Enter your new password below.
        </p>
        <form
          className="w-full max-w-md flex flex-col gap-6"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="flex flex-col">
            <label
              className="text-gray-700 font-medium mb-2 text-base"
              htmlFor="new-password"
            >
              New Password
            </label>
            <div className="relative flex items-center">
              <input
                id="new-password"
                className="w-full py-3 px-4 border-2 border-gray-200 rounded-lg bg-white text-gray-900 focus:outline-none focus:border-[#da0e1a] transition-colors text-base"
                type={showPassword ? "text" : "password"}
                placeholder="Enter new password"
                {...register("password")}
              />
              <button
                type="button"
                onClick={() => setShowPassword((prev) => !prev)}
                className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                tabIndex={-1}
              >
                {showPassword ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={20}
                    height={20}
                    viewBox="0 0 16 16"
                    fill="currentColor"
                  >
                    <path d="m10.12 10.827l4.026 4.027a.5.5 0 0 0 .708-.708l-13-13a.5.5 0 1 0-.708.708l3.23 3.23A6 6 0 0 0 3.2 6.182a6.7 6.7 0 0 0-1.117 1.982c-.021.061-.047.145-.047.145l-.018.062s-.076.497.355.611a.5.5 0 0 0 .611-.355l.001-.003l.008-.025l.035-.109a5.7 5.7 0 0 1 .945-1.674a5 5 0 0 1 1.124-1.014L6.675 7.38a2.5 2.5 0 1 0 3.446 3.446m-.74-.74A1.5 1.5 0 1 1 7.413 8.12zM6.32 4.2l.854.854Q7.564 5 8 5c2.044 0 3.286.912 4.028 1.817a5.7 5.7 0 0 1 .945 1.674q.025.073.035.109l.008.025v.003l.001.001a.5.5 0 0 0 .966-.257v-.003l-.001-.004l-.004-.013a2 2 0 0 0-.06-.187a6.7 6.7 0 0 0-1.117-1.982C11.905 5.089 10.396 4 8.002 4c-.618 0-1.177.072-1.681.199" />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={20}
                    height={20}
                    viewBox="0 0 16 16"
                    fill="currentColor"
                  >
                    <path d="M8 6.003a2.667 2.667 0 1 1 0 5.334a2.667 2.667 0 0 1 0-5.334m0 1a1.667 1.667 0 1 0 0 3.334a1.667 1.667 0 0 0 0-3.334m0-3.336c3.076 0 5.73 2.1 6.467 5.043a.5.5 0 1 1-.97.242a5.67 5.67 0 0 0-10.995.004a.5.5 0 0 1-.97-.243A6.67 6.67 0 0 1 8 3.667" />
                  </svg>
                )}
              </button>
            </div>
            {errors.password && (
              <p className="text-red-500 text-sm mt-1">
                {errors.password.message}
              </p>
            )}
          </div>
          {/* <div className="flex flex-col">
            <label
              className="text-gray-700 font-medium mb-2 text-base"
              htmlFor="confirm-password"
            >
              Confirm Password
            </label>
            <input
              id="confirm-password"
              className="w-full py-3 px-4 border-2 border-gray-200 rounded-lg bg-white text-gray-900 focus:outline-none focus:border-[#da0e1a] transition-colors text-base"
              type="password"
              placeholder="Confirm new password"
              {...register("confirmPassword")}
            />
            {errors.confirmPassword && (
              <p className="text-red-500 text-sm mt-1">
                {errors.confirmPassword.message}
              </p>
            )}
          </div> */}
          <button
            type="submit"
            disabled={loading}
            className="bg-gradient-to-r from-[#da0e1a] to-[#c40d17] rounded-lg w-full py-3 font-semibold text-xl cursor-pointer transition-colors hover:from-[#c40d17] hover:to-[#da0e1a] mb-2 text-white flex items-center justify-center gap-3 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading && (
              <svg
                className="animate-spin h-6 w-6 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v8z"
                ></path>
              </svg>
            )}
            {loading ? "Resetting..." : "Reset Password"}
          </button>
        </form>
        {successMessage && (
          <div className="text-green-600 text-center mt-6 bg-green-50 p-4 rounded-lg">
            {successMessage}
          </div>
        )}
        {errorMessage && (
          <div className="text-red-600 text-center mt-6 bg-red-50 p-4 rounded-lg">
            {errorMessage}
          </div>
        )}
      </div>
    </div>
  );
}

export default ResetPassword;
